export default __webpack_public_path__ + "static/media/CV_Anthony-Luong.7773592f.pdf";